
export default {
    state: {
        showToast:'',
        yujinType:'操作成功',
        companyinfo:{
            mediaLevelList:{},
            version:''
        }
    },

    mutations: {
        setToastData(state,data){
            state.showToast = data.text;
        },
        setYujinData(state,data){
            state.yujinType = data.text;
        },
        setCompanyinfo(state,data){
            state.companyinfo = data.config;
        },
    },

    actions: {
        changeToast({commit},parms){
            commit('setToastData',parms)

        },
        yujinType({commit},parms){
            commit('setYujinData',parms)

        },
        companyinfo({commit},parms){
            commit('setCompanyinfo',parms)

        },
    },
    namespaced: true
}



// WEBPACK FOOTER //
// ./src/store/modules/show.js